import React from 'react';
import { MonkeyLogo } from '../MonkeyLogo';

/* ─── Branding footer + affiliate CTA ─── */
export const ProfileFooter = ({ profile, ts, isDarkTheme }) => {
  return (
    <>
        {/* Branding + Beta Notice */}
        {!profile.hide_branding && (
        <div className="mt-12 pt-6 space-y-3" style={{ borderTop: `1px solid ${ts['--theme-card-border']}` }}>
          {profile.is_affiliate && profile.referral_url ? (
            <p className="text-xs text-center leading-relaxed px-4" style={{ color: ts['--theme-text-muted'], opacity: 0.85 }} data-testid="affiliate-cta">
              Want your own LinkMonkey page? <a href={profile.referral_url} target="_blank" rel="noopener noreferrer" className="underline font-semibold" style={{ color: ts['--theme-text'] }}>Sign up with my link →</a>
            </p>
          ) : (
            <p className="text-xs text-center leading-relaxed px-4" style={{ color: ts['--theme-text-muted'], opacity: 0.8 }} data-testid="beta-notice">
              Want your own link in bio? <a href="/" target="_blank" rel="noopener noreferrer" className="underline font-semibold" style={{ color: ts['--theme-text'] }}>linkmonkey.io →</a>
            </p>
          )}
          <a href="/" target="_blank" rel="noopener noreferrer"
            className="inline-flex items-center justify-center space-x-2 px-3 py-1.5 rounded-full opacity-90 hover:opacity-100 transition-opacity"
            style={{ background: isDarkTheme ? 'rgba(255,255,255,0.08)' : 'rgba(20,20,20,0.06)', border: `1px solid ${ts['--theme-card-border']}` }}
            data-testid="linkmonkey-branding">
            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full"
              style={{ background: isDarkTheme ? 'rgba(255,255,255,0.92)' : 'rgba(20,20,20,0.92)' }}>
              <MonkeyLogo size={16} />
            </span>
            <span className="text-sm font-medium" style={{ color: ts['--theme-text'] }}>Powered by LinkMonkey</span>
          </a>
        </div>
        )}
    </>
  );
};
